import { post, postJson, deleteApi, put, get, imagePost, putJson,postBlob } from './axios3'

// 创建问卷调查
export const questionnaireSave = p => postJson(`/questionnaire/save`, p)

// 查询问卷调查详情
export const questionnaireDetail = id => get(`/questionnaire/${id}`)

// 查询问卷调查记录
export const getQuestionnaireRecord = p => postJson(`/questionnaire/getRecordPage`, p)

// 导出问卷调查记录
export const exportQuestionnaireRecord = p => postJson(`/questionnaire/exportRecord`, p)

//问卷统计
export const getQuestionSummary = p => get('/questionnaire/getQuestionSummary', p)

//参与记录导出
export const trialRebuyExport = p => postJson(`/trialRebuy/export`, p)

//领奖记录导出
export const winRecordExports = p => postJson(`/trialRebuy/winRecordExport`, p)

// 查询晒图PK参与记录
export const getPhotoContestRecord = p => postJson(`/showImageGift/joinRecord`, p)

// 晒图PK参与记录导出
export const exportPhotoContestRecord = p => postJson(`/showImageGift/joinRecord/export`, p)

// 查询晒图PK参与记录详情
export const getPhotoContestRecordDetail = p => postJson(`/showImageGift/likeRecordPage`, p)


// 批量审核
export const batchAudit = p => postJson(`/showImageGift/batchAudit`, p)

// 批量标记中奖
export const batchWinBatch = p => postJson(`/showImageGift/batchMarkWin`, p)
